module.exports = __webpack_public_path__ + "img/introduction-music.48025182.png";